import React from 'react'
import { Link } from 'react-router-dom'
import { Parallax } from 'react-scroll-parallax';
import MediaQuery from 'react-responsive';

const TopSection = () => (
  <div className="button-bar">
    <MediaQuery maxWidth={639}>

    <Parallax translateX={[0, 100]} className="button-one">
        {/* <div className="buttons">
          <a href="//support.4zzz.org.au/subscriptions" target="_blank">
						<div style={{ width: '50vw', height: '50vw', background: 'url(assets/radiothon-guitar.png)', backgroundSize: 'contain', filter: 'drop-shadow(1px 1px 1px white) drop-shadow(-1px -1px 1px white)drop-shadow(1px -1px 1px white) drop-shadow(-1px 1px 1px white)' }}></div>
					</a>
        </div> */}
      </Parallax>

      <Parallax translateX={[40, 0]} className="button-one">
        <div className="buttons">
					<a href="//support.4zzz.org.au/subscriptions" target="_blank">
						<div style={{ marginTop: '10vw', fontSize: '40px' }}>Subscribe</div>
					</a>
        </div>
      </Parallax>

      <Parallax translateX={[0, 100]}  className="button-two">
        {/* <div className="buttons">
          <Link to="/radiothon">
						<div style={{ width: '50vw', height: '50vw', background: 'url(assets/radiothon-keys.png)', backgroundSize: 'contain', filter: 'drop-shadow(1px 1px 1px white) drop-shadow(-1px -1px 1px white)drop-shadow(1px -1px 1px white) drop-shadow(-1px 1px 1px white)' }}></div>
					</Link>
        </div> */}
      </Parallax>

      <Parallax translateX={[0, 40]}  className="button-two">
        <div className="buttons">
					<Link to="/radiothon">
						<div style={{ marginTop: '10vw', fontSize: '40px'}}>Prizes</div>
					</Link>
        </div>
      </Parallax>

      <Parallax translateX={[0, 100]} className="button-three">
        {/* <div className="buttons">
          <Link to="/support">
						<div style={{ width: '50vw', height: '50vw', background: 'url(assets/radiothon-rap.png)', backgroundSize: 'contain', filter: 'drop-shadow(1px 1px 1px white) drop-shadow(-1px -1px 1px white)drop-shadow(1px -1px 1px white) drop-shadow(-1px 1px 1px white)' }}></div>
					</Link>
        </div> */}
      </Parallax>

      <Parallax translateX={[40, 0]} className="button-three">
        <div className="buttons">
					<Link to="/support">
						<div style={{ marginTop: '10vw', fontSize: '40px' }}>Support</div>
					</Link>
        </div>
      </Parallax>
    </MediaQuery>

    <MediaQuery minWidth={640} values={{ width: 1600 }}>

      <Parallax translateY={[100, 100]} className="button-one">
        {/* <div className="buttons">
          <a href="//support.4zzz.org.au/subscriptions" target="_blank">
						<div style={{ top: 'calc(50vh - (30vw / 2))', margin: '1vw', width: '28vw', height: '28vw', background: 'url(assets/radiothon-guitar.png)', backgroundSize: 'contain', filter: 'drop-shadow(1px 1px 1px white) drop-shadow(-1px -1px 1px white)drop-shadow(1px -1px 1px white) drop-shadow(-1px 1px 1px white)' }}></div>
					</a>
        </div> */}
      </Parallax>

      <Parallax translateY={[-50, 50]} className="button-one">
        <div className="buttons">
          <a href="//support.4zzz.org.au/subscriptions" target="_blank">
						<div style={{ top: 'calc(50vh - (30vw / 2))', fontSize: '5vw' }}>Subscribe</div>
					</a>
        </div>
      </Parallax>

      <Parallax translateY={[0, 100]}  className="button-two">
        {/* <div className="buttons">
          <Link to="/radiothon">
						<div style={{ top: 'calc(50vh - (30vw / 2))', margin: '1vw', width: '28vw', height: '28vw', background: 'url(assets/radiothon-keys.png)', backgroundSize: 'contain', filter: 'drop-shadow(1px 1px 1px white) drop-shadow(-1px -1px 1px white)drop-shadow(1px -1px 1px white) drop-shadow(-1px 1px 1px white)' }}></div>
					</Link>
        </div> */}
      </Parallax>
      
      <Parallax translateY={[50, -50]} className="button-two">
        <div className="buttons">
          <Link to="/radiothon">
						<div style={{ top: 'calc(50vh - (30vw / 2))', fontSize: '5vw' }}>Prizes</div>
					</Link>
        </div>
      </Parallax>


      <Parallax translateY={[100, 0]} className="button-three">
        {/* <div className="buttons">
          <Link to="/support">
						<div style={{ top: 'calc(50vh - (30vw / 2))', margin: '1vw', width: '28vw', height: '28vw', background: 'url(assets/radiothon-rap.png)', backgroundSize: 'contain', filter: 'drop-shadow(1px 1px 1px white) drop-shadow(-1px -1px 1px white)drop-shadow(1px -1px 1px white) drop-shadow(-1px 1px 1px white)' }}></div>
					</Link>
        </div> */}
      </Parallax>

      <Parallax translateY={[-50, 50]} className="button-three">
        <div className="buttons">
          <Link to="/support">
						<div style={{ top: 'calc(50vh - (30vw / 2))', fontSize: '5vw' }}>Support</div>
					</Link>
        </div>
      </Parallax>

    </MediaQuery>
  </div>
)

export default TopSection
